import { deleteOrdersReviewReviewId } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.partnerReviewMutations;

export const useDeletePartnerReviewMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (reviewId: number) => deleteOrdersReviewReviewId(reviewId),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.deleteReviewError)}:`, error);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: orderKeys.review(orderId) }),
				queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) }),
			]);
			toast.success(t(orderMutationsResource.deleteReviewSuccess));
		},
	});
};
